import { FrontendConfiguration } from '../../configuration/config.patientportal';

export class ApiRoutes {
    static Base: string = this.getBackendBaseUrl() + '/api';
    static Patient: ApiRoute = <ApiRoute>{
        Get: this.Base + '/patients/{patientId}',
    };
    static PatientStudy: ApiRoute = <ApiRoute>{
        Get: this.Base + '/patients/{patientId}/studies',
    };
    static PatientSite: ApiRoute = <ApiRoute>{
        Get: this.Base + '/patients/{patientId}/sites',
    };
    static PasswordReset: ApiRoute = <ApiRoute>{
        Post: this.Base + '/auth/resetpassword',
    };
    static StudyLogo: ApiRoute = <ApiRoute>{
        Get: this.Base + '/storage/studylogo/{id}',
    };
    static Version: ApiRoute = <ApiRoute>{
        Get: this.Base + '/version',
    };
    static Files: ApiRoute = <ApiRoute>{
        Post: this.Base + '/files/reimbursementTransaction/upload',
    };

    /* istanbul ignore next */
    /**
     * @returns Base URL of the backend with which the frontend should communicate. The returned value does NOT end with '/'.
     * Do not use when you neeed the front-end base URL. While they might be the same in the PWA context, they are different when running in a mobile app context!
     */
    static getBackendBaseUrl(): string {
        const frontendConfiguration = new FrontendConfiguration();
        const backendUrlFromConfiguration = new URL(frontendConfiguration.backendUrl);

        // If developer runs app on a laptop with Dev Tunnels enabled (usually, to expose it to public internet for Android debugging),
        // we need to replace "https://localhost:5002" with the actual Dev Tunnel domain (something like https://abcd-5002.euw.devtunnels.ms/).
        if (window.location.hostname.toLowerCase().includes('.devtunnels.ms')) {
            return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        }

        return backendUrlFromConfiguration.origin;
    }
}

export interface ApiRoute {
    GetAll: string;
    Get: string;
    Post: string;
}
